export default "__VITE_ASSET__d6d420e7__"